{
    "MainTitleAdd": "Instellingen voor centrale beheeromgeving.",
    "MainTitleModify": "Instellingen voor centrale beheeromgeving.",
    "DomainsTitle": "Domeinprofiel",
    "ProvisioningTitle": "Provisioning",
    "EstateTitle": "Estate",
    "UnknownDescription": "[Onbekende beschrijving]",
    "LanguageCME_ButtonHelpLabel": "Helpen?",
    "LanguageCME_ButtonSubmitLabel": "Oke",
    "LanguageCME_ButtonCancelLabel": "Annuleren",
    "LanguageCME_PromptMessage": "Weet u zeker dat u dit venster wilt sluiten? Alle gewijzigde configuraties gaan verloren wanneer ze worden gesloten.",
    "LanguageCME_PromptConfirm": "Ja",
    "LanguageCME_PromptCancel": "Annuleren",
    "LanguageCME_DetailsTitle": "CME-details",
    "NAME": "LanguageCME",
    "LicenseManagementTitle": "Licentiebeheer",
    "CME_AdvancedTabTitle": "Geavanceerd",
    "CME_Fields_RecursiveRealTimeBots": "Real-time inschakelen\/uitschakelen voor alle Tel Servers",
    "CME_EnableVoiceAppBots": "Real-time starten voor {} Tel Servers",
    "CME_EnableVoiceAppBots_Recursive": "Real-time starten voor alle Tel Servers",
    "CME_DisableVoiceAppBots": "Stop real-time voor {} Tel Servers",
    "CME_DisableVoiceAppBots_Recursive": "Real-time stoppen voor alle Tel Servers",
    "CME_EnableVoiceAppBots_Confirmation_Title": "Houd er rekening mee dat het activeren van deze optie kan leiden tot een verslechtering van de functionaliteit binnen de huurder. Deze optie mag alleen worden gebruikt na overleg met ons ondersteuningsteam.",
    "CapabilitiesTitle": "Mogelijkheden",
    "BrandingTitle": "Merknaam"
}